import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import { baseClass, ruleTags } from '@/components/rules/utils'

function renderComponent(h) {
  return h(
    this.$_component,
    {
      props: this.$_props,
      on: this.$_on
    }
  )
}
function renderAddButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.add'),
        mode: buttonModes.flat,
        color: Colors.primary,
        disabled: !this.pattern
      },
      on: {
        click: () => {
          this.proxy.push(this.pattern)
          this.pattern = undefined
        }
      }
    }
  )
}
function renderSection(h) {
  return h(
    'div',
    {
      class: `${baseClass}-dialog__content-section--${this.tag}`
    },
    [
      renderComponent.call(this, h),
      renderAddButton.call(this, h)
    ]
  )
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${baseClass}.hints.yulore`)
      }
    }
  )
}

export default function(h) {
  switch (this.tag) {
    case ruleTags.group: return renderSection.call(this, h)
    case ruleTags.yulore: return renderInfo.call(this, h)
    default: return renderComponent.call(this, h)
  }
}
